<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmPrognostico"
      :title="'CADASTRO DE PROGNÓSTICO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-12">
          <label
            ><small
              v-if="form.nome.required"
              class="text-danger"
              >*</small
            >
            Prognostico:</label
          >
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome do Prognostico'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import { advancedOnException } from '@/components/tools/Utils'

import PrognosticoModel from '@/shared/models/configurations/prognosticomodel.js'
import PrognosticoForms from './prognostico-form.js'
import PrognosticoRepository from '@/shared/http/repositories/configurations/prognostico.js'

export default {
  name: 'ComarcaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: PrognosticoModel,
      form: PrognosticoForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      PrognosticoRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      PrognosticoRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/prognostico/components/add/prognosticoadd.vue